class VideoQuery {
    constructor(parent, data) {
        this.videos = []
        this.parent = parent
        this.init()
    }
    init() {
        document.querySelectorAll('[data-video-mobile]').forEach(el => {
            const item = new VideoQueryItem(el)
            this.videos.push(item)
            item.test()
        })

        window.addEventListener('resize', () => {
            this.videos.forEach(el => el.test())
        })
    }
}

class VideoQueryItem {
    constructor(el) {
        this.el = el

        this.src = this.el.getAttribute('src');
        this.srcMobile = this.el.dataset.videoMobileSrc;
        this.query = this.el.dataset.videoMobile;
    }

    test() {
        const mql = window.matchMedia(this.query)
        if (mql.matches) {
            this.setSrc(this.srcMobile)
        } else {
            this.setSrc(this.src)
        }
    }

    setSrc(src) {
        if (this.el.getAttribute('src').replace('http', '').replace('https', '') === src) {
            return
        }
        this.el.src = src
    }
}

export default VideoQuery